import React, { useEffect, useState } from "react";
import "./cartListStyle.css";
import io from "socket.io-client";
import axios from "axios";
import { useSelector } from "react-redux";
import { getInvoiceReceipt } from "../../../Sales/Billing/API/billingPaymentSection";
import QRCode from 'react-qr-code';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import Lottie from "react-lottie";
import FoodMoveAnimation from "../../../../../lottie/FoodMove.json";

const CartList = () => {
  const { branchPk, data, ...rest } = useSelector(
    (state) => state.loginResponseSlice.value
  );
  
  const [cartData, setCartData] = useState();
  const [qrDisplayInfo,setQRDisplayInfo]=useState()

  useEffect(() => {
    console.log('🖥️ Customer Display: Initializing socket connection...');
    console.log('🖥️ Customer Display: branchPk:', branchPk, 'userId:', data?._id);
    
    const socket = io(axios.defaults.baseURL, {
      path: "/socket.io/",
      reconnection: true,
      transports: ["websocket"],
      reconnectionAttempts: 5,
    });

    socket.on("connect", () => {
      console.log('🖥️ Customer Display: Socket connected!');
      if (data && branchPk) {
        console.log('🖥️ Customer Display: Setting username with userId:', data?._id, 'branchPk:', branchPk);
        socket.emit("setUsername", data?._id, branchPk);
      } else {
        console.warn('🖥️ Customer Display: Missing data or branchPk, cannot set username');
      }
    });

    socket.on("usernameSet", (res) => {
      console.log('🖥️ Customer Display: Username set confirmed:', res);
    });

    socket.on("posBillingCart", (res) => {
      console.log('🖥️ Customer Display: Received cart update:', res);
      
      // Only update cart data if there's actual cart data (not just QR update)
      if (res?.orderInfo?.length > 0 || res?.subTotal > 0) {
        setCartData(res);
      }
      
      // Handle QR display info
      const qrInfo = res?.customerDisplayQRInfo;
      console.log('🖥️ Customer Display: QR Info:', qrInfo);
      
      if (qrInfo?.orderId) {
        getInvoiceReceipt({orderId: qrInfo.orderId});
      }
      
      // Update QR display based on status - check status FIRST before open
      if (qrInfo?.status === 'success') {
        console.log('🖥️ Customer Display: Payment SUCCESS - amount:', qrInfo?.amount);
        // Show success state
        setQRDisplayInfo({
          ...qrInfo,
          open: true
        });
        // Clear cart after success display (3 seconds)
        setTimeout(() => {
          console.log('🖥️ Customer Display: Clearing screen for next customer');
          setCartData(null);
          setQRDisplayInfo(null);
        }, 3000);
      } else if (qrInfo?.status === 'declined') {
        console.log('🖥️ Customer Display: Payment DECLINED');
        // Show declined state with QR for retry
        setQRDisplayInfo({
          ...qrInfo,
          open: true
        });
      } else if (qrInfo?.open) {
        console.log('🖥️ Customer Display: Showing QR - pending payment');
        setQRDisplayInfo(qrInfo);
      } else {
        // Close QR display
        setQRDisplayInfo(null);
      }
    });

    socket.on("error", (error) => {
      console.error('🖥️ Customer Display: Socket error:', error);
    });

    return () => {
      // Clean up event listeners
      console.log('🖥️ Customer Display: Cleaning up socket connection...');
      socket.off("connect");
      socket.off("usernameSet");
      socket.off("posBillingCart");
      socket.off("error");
      socket.disconnect();
    };
  }, [data, branchPk]);

  return (
    <div className="cart-list-container">
      <div className="cart-list-table-wrapper">
        <table>
          <thead>
            <tr>
              <th className="cd-text-start" style={{ width: '50%' }}>Item Name</th>
              <th className="cd-tex-end">Price</th>
              <th className="cd-tex-end">Quantity</th>
              <th className="cd-tex-end">Total</th>
            </tr>
          </thead>
          <tbody>
            {cartData?.orderInfo?.length > 0 ? (
              cartData?.orderInfo?.map((item, i) => (
                <tr key={item?._id || i}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <img 
                        src={item?.imageUrl || '/placeholder-food.png'} 
                        alt={item?.desccription}
                        style={{ 
                          width: '50px', 
                          height: '50px', 
                          borderRadius: '8px', 
                          objectFit: 'cover',
                          backgroundColor: '#1a237e'
                        }}
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                      <span>{item?.desccription}</span>
                    </div>
                  </td>
                  <td className="cd-tex-end">{Number(item?.unitPrice || 0).toFixed(2)}</td>
                  <td className="cd-tex-end">{item?.qty}</td>
                  <td className="cd-tex-end">{Number(item?.subTotalWoTax || 0).toFixed(2)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4}>
                  <div style={{height:'79vh', display: "flex", placeContent: "center",alignItems:'center',padding:'1em',flexDirection:'column' }}>
                    <Lottie 
                      options={{
                        loop: true,
                        autoplay: true,
                        animationData: FoodMoveAnimation,
                        rendererSettings: {
                          preserveAspectRatio: 'xMidYMid slice'
                        }
                      }}
                      height={350}
                      width={350}
                    />
                    <h3 style={{ marginTop: '1rem', fontSize: '2rem', color: '#1a237e' }}>Next Customer !!</h3>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={3}>Sub Total</td>
              <td className="cd-tex-end">{Number(cartData?.subTotal || 0).toFixed(2)}</td>
            </tr>
            {cartData?.taxTotal > 0 && (
              <tr>
                <td colSpan={3}>Tax</td>
                <td className="cd-tex-end">{Number(cartData?.taxTotal || 0).toFixed(2)}</td>
              </tr>
            )}
            <tr className="grand-total-row">
              <td colSpan={3}><strong>Grand Total</strong></td>
              <td className="cd-tex-end"><strong>{Number(cartData?.grandTotal || 0).toFixed(2)}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* UPI Payment QR Display */}
      {qrDisplayInfo?.open && (
        <div className="customer-display-qr-overlay">
          <div className="customer-display-qr-container">
            {/* Payment Success State */}
            {qrDisplayInfo?.status === 'success' ? (
              <div className="payment-status-container success">
                <CheckCircleIcon sx={{ fontSize: 120, color: '#4CAF50' }} />
                <h2>Payment Successful!</h2>
                <p className="amount">{qrDisplayInfo?.currency || 'AED'} {Number(qrDisplayInfo?.amount || 0).toFixed(2)}</p>
                <p className="thank-you">Thank you for your payment</p>
              </div>
            ) : qrDisplayInfo?.status === 'declined' ? (
              /* Payment Declined State */
              <div className="payment-status-container declined">
                <ErrorIcon sx={{ fontSize: 120, color: '#f44336' }} />
                <h2>Payment Declined</h2>
                <p className="message">Please try again or use another payment method</p>
                <div className="qr-section">
                  <p className="scan-text">Scan to retry payment</p>
                  <QRCode 
                    value={`upi://pay?pa=${qrDisplayInfo?.bankAccount}&pn=${encodeURIComponent(qrDisplayInfo?.payeeName || '')}&am=${qrDisplayInfo?.amount}&cu=INR`} 
                    size={180} 
                  />
                </div>
              </div>
            ) : (
              /* Pending Payment State - Show QR */
              <div className="payment-status-container pending">
                <h2>Scan to Pay</h2>
                <p className="payee-name">{qrDisplayInfo?.payeeName}</p>
                <div className="qr-code-wrapper">
                  <QRCode 
                    value={`upi://pay?pa=${qrDisplayInfo?.bankAccount}&pn=${encodeURIComponent(qrDisplayInfo?.payeeName || '')}&am=${qrDisplayInfo?.amount}&cu=INR`} 
                    size={220} 
                  />
                </div>
                <p className="amount">{qrDisplayInfo?.currency || 'AED'} {Number(qrDisplayInfo?.amount || 0).toFixed(2)}</p>
                <p className="instruction">Scan QR code with any UPI app to pay</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CartList;
